<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import InboxActionToggleCell from "../../../../../../_shared/_modules/inbox-action-toggle-cell"
  import type { AssignRequesterCustomerDraft, AssignRequesterCustomerRow } from "../../contract"

  let props: InboxWorkflowCellProps<AssignRequesterCustomerRow, AssignRequesterCustomerDraft> =
    $props()

  const value = $derived(String(props.binding.value ?? ""))
  const options = $derived(
    props.binding.options.map((option) => {
      const customerId = option.value.startsWith("existing:")
        ? option.value.slice("existing:".length)
        : ""
      const candidate = props.row.customerOptions.find((entry) => entry.customerId === customerId)

      return {
        value: option.value,
        label: option.label ?? option.name ?? option.value,
        ariaLabel: candidate ? `${candidate.displayName} zuordnen` : undefined,
        disabled: option.disabled,
        tooltip: option.tooltip,
        tooltipContent: option.tooltipContent,
        dataTestid: option.dataTestid,
      }
    }),
  )
</script>

<InboxActionToggleCell
  {value}
  {options}
  disabled={props.binding.disabled}
  ariaLabel={`Als was ${props.row.customerLabel} speichern?`}
  wrap={true}
  allowEmptySelection={true}
  onChange={(next) => props.binding.setValue(next)}
/>
